export default __webpack_public_path__ + "static/media/Demoportfolio.c15256d3.png";